export default __webpack_public_path__ + "static/media/b.27faba78.jpg";